export default __webpack_public_path__ + "static/media/dish-min.63ce27eb.png";